import {
  CLEAR_COURSE_CONTENT,
  EMPTY_COURSE_CONTENT,
  FETCH_COURSE_CONTENT,
  FETCH_COURSE_CONTENT_SUCCESS,
  HANDLE_REQUEST_CLOSE,
  SET_NEXT_CONTENT,
  SET_PREVIOUS_CONTENT,
  SET_CURRENT_CONTENT,
  SHOW_MESSAGE,
  VIEW_CONTENT,
  TOGGLE_AUTO_PLAY,
  SET_VIDEO_END,
  UNSET_VIDEO_END
} from "../constants/ActionTypes";

export const fetchCourseContent = (SessionID) => {
  return {
    type: FETCH_COURSE_CONTENT,
    payload: SessionID,
  };
};

export const fetchCourseContentSuccess = (response) => {
  
  if(typeof response === 'undefined')
  return emptyCourseContent();
  else if(response.data === null){
    // debugger
  return emptyCourseContent();
  }
  else if(response.state > 0 && response.data)
  return {
    type: FETCH_COURSE_CONTENT_SUCCESS,
    payload: response.data,
  };
  else return showCourseMessage(response.msg);
};

export const fetchCourseContentResponse = (response) => {
  // console.log({response})
  if (response.data && response.status === 200) return fetchCourseContentSuccess(response.data);
  else return showCourseMessage("An error occured");
};

export const showCourseMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message,
  };
};

export const handleCourseRequestClose = () => {
  return {
    type: HANDLE_REQUEST_CLOSE,
  };
};

export const viewCourseContent = (payload) => {
  return {
    type: VIEW_CONTENT,
    payload
  };
};

export const clearCourseContent = () => {
  return {
    type: CLEAR_COURSE_CONTENT
  };
};

export const emptyCourseContent = () => {
  return {
    type: EMPTY_COURSE_CONTENT
  };
};

export const setCurrentContent = ({parentIndexC, childIndexC}) => {
  // debugger
  return {
    type: SET_CURRENT_CONTENT,
    payload: {parentIndexC, childIndexC}
  };
}

export const setNextContent = () => {
  // debugger
  return {
    type: SET_NEXT_CONTENT
  };
}

export const setPreviousContent = () => {
  // debugger
  // console.log('viewPreviousContent was clicked')
  return {
    type: SET_PREVIOUS_CONTENT
  };
}

export const toggleAutoplay = () => {
  return {
    type: TOGGLE_AUTO_PLAY
  };
}

export const setVideoEnd = () => {
  return {
    type: SET_VIDEO_END
  }
}

export const unsetVideoEnd = () => {
  return {
    type: UNSET_VIDEO_END
  }
}

